import { SHStack, SHTypography } from "@components/design-systems";
import { AnalysisDataDTO } from "@models/platform-analysis/entities/steps/feature";
import { memo } from "react";

interface SummaryAnalysisTableTotalScoreCellProps {
  analysisData?: AnalysisDataDTO;
}
export const SummaryAnalysisTableTotalScoreCell = memo(
  ({ analysisData }: SummaryAnalysisTableTotalScoreCellProps) => {
    return (
      <SHStack
        className={`SummaryAnalysisTableScoreCell ${
          analysisData?.isMissingEssential ? "missing-essential" : ""
        }`}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <SHTypography variant="subtitle2" sx={{ textAlign: "center" }}>
          {analysisData?.totalScore}%
        </SHTypography>
      </SHStack>
    );
  },
);
